/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect } from 'react'; // eslint-disable-next-line
// eslint-disable-next-line
import { copiriAxiosPost, copiriAxiosGet, checkValidation, copiriPortalRequest } from '../../api/api'; // eslint-disable-next-line
import config from '../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'react-bootstrap';
import FormGroupInput from '../../common/FormGroupInput';
import image_loader from '../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
import { genPageData } from '../../langconfig/langconfig'; // eslint-disable-next-line
const EditLodgeNameModal = props => {
	const { lodgeData, pageLanguageContent } = props;
	const [checkDataChange, setCheckDataChange] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [formattedName, setFormattedName] = useState(lodgeData['name']); // eslint-disable-next-line
	const [disabledNumberField, setDisabledNumberField] = useState(false);
	const [showHideUDSection, setShowHideUDSection] = useState(false);
	const [inputField, setInputField] = useState({
		name: '',
		lodge_number: '',
		u_d: ''
	});

	/* input validation constants*/
	const [validation, setValidation] = useState({
		error_name: '',
		error_number: ''
	});

	useEffect(() => {
		if (props.showHideModal) {
			orgDetailsData(lodgeData?.id);
			const { provisional } = lodgeData;
			if (provisional) {
				setDisabledNumberField(false);
			} else {
				setDisabledNumberField(false);
			}
		}
		// eslint-disable-next-line
	}, [props.showHideModal]);

	function orgDetailsData(id) {
		copiriPortalRequest('/organizations/' + id + '?format=lodges', config.app_version, 'get')
			.then(response => {
				if (response?.data?.result) {
					const { organizationName, organizationNumber } = response?.data?.result;
					setFormattedName(response?.data?.result?.name);
					setInputField({
						...inputField,
						name: organizationName,
						lodge_number: organizationNumber,
						u_d: lodgeData['provisional'] ? true : false
					});
				}
			})
			.catch(error => {});
	}

	/* function to get the input data */
	const inputsHandler = (e, type) => {
		setCheckDataChange(true);
		//setInputField( {[e.target.name]: e.target.value} )
		setInputField({ ...inputField, [e.target.name]: e.target.value });
		if (type === 'name') {
			if (inputField['u_d'] && inputField['u_d'] === 'true') {
				format_org_name(e.target.value, inputField['lodge_number'], true);
			} else {
				format_org_name(e.target.value, inputField['lodge_number'], false);
			}
		}

		if (type === 'number') {
			if (inputField['u_d'] && inputField['u_d'] === 'true') {
				format_org_name(inputField['name'], e.target.value, true);
			} else {
				format_org_name(inputField['name'], e.target.value, false);
			}
		}
		if (type === 'ud') {
			if (e.target.value === 'true') {
				setDisabledNumberField(false);
				format_org_name(inputField['name'], inputField['lodge_number'], true);
			} else {
				setDisabledNumberField(false);
				format_org_name(inputField['name'], inputField['lodge_number'], false);
			}
		}
	};

	/* function to format the organization name */
	function format_org_name(name, number, provisional) {
		// Default our response
		let formatted = '';

		// Clean up the name string
		if (name) name = name.trim();
		// Clean up the number string
		if (number) number = number.trim();

		// If we don't have a name or number, there's nothing to do here.
		if (!name && !number) return formatted;

		// If we don't have a name AND the Lodge is provisional... the number
		// doesn't matter, so there's nothing to do here.
		if (!name && provisional) return formatted;

		// Start the response.  If we have a name, and it includes the word "Lodge"
		// or a known translation, use it as-is.
		if (
			(name && name.indexOf('Lodge') >= 0) ||
			name.indexOf('Loge') >= 0 ||
			name.indexOf('Loja') >= 0 ||
			name.indexOf('Logia') >= 0
		)
			formatted = name;
		// Otherwise, add it along with the word "Lodge".
		// NOTE :: for empty names, just add "Lodge" without the space.
		else formatted = name ? name : '';

		if (provisional === true) {
			formatted += ', ' + pageLanguageContent['CLD014'];
		} else {
			formatted += number ? ' ' + pageLanguageContent['CLD080'] + ' ' + number : '';
		}

		/*formatted += number ? ' '+pageLanguageContent['CLD027']+'. ' + number : '';
		// If the "Provisional" box was checked, overwrite the "Number" box.
		if (provisional === true) formatted += ', '+pageLanguageContent['CLD014'];
		// Otherwise, add whatever we have to the return value
		// Note that if the name was empty on entry, it is now "Lodge".
		else ;*/

		setFormattedName(formatted);
	}

	/* function to update the data */
	function updateData() {
		let errors = { ...validation };
		var errorCount = 0;
		if (!inputField.name.trim()) {
			errors.error_name = pageLanguageContent['CLD071'];
			errorCount++;
		} else {
			errors.error_name = '';
		}
		setValidation(errors);
		if (errorCount <= 0) {
			if (checkDataChange) {
				var sendFormData = {};
				var sendData = {};
				inputField['name'] = inputField['name']
					.replace(' Lodge ', '')
					.replace('.', '')
					.replace('Lodge', '')
					.replace('Lodge ', '')
					.replace('No. ', '')
					.replace('No.', '')
					.replace('No', '');
				sendFormData['provisional'] = false;
				if (inputField['u_d'] && inputField['u_d'] === 'true') {
					sendFormData['provisional'] = true;
				}
				sendFormData['name'] = inputField['name'];
				sendFormData['number'] = inputField['lodge_number'];
				sendFormData['nameShort'] = inputField['name'];
				sendData['value'] = sendFormData;
				setShowLoader(true);
				copiriPortalRequest('/organizations/' + lodgeData['id'], config.app_version, 'patch', sendFormData)
					.then(response => {
						setShowLoader(false);
						if (response.data.status && response.data.status === 'SUCCESS') {
							toast.success(pageLanguageContent['CLD119']);
							props.closeModal();
							document.getElementById('org_name_' + lodgeData['id']).innerHTML = formattedName;
							document.getElementById('udpated_lodge_name').innerHTML = formattedName;
						}
						if (inputField['u_d'] && inputField['u_d'] === 'true') {
							props.updateLodgeModal('provisional', true);
						} else {
							props.updateLodgeModal('provisional', false);
						}
					})
					.catch(error => {
						toast.error(error.response.data.result);
						setShowLoader(false);
					});
			}
		}
	}

	/* function to show/hide UD section row */
	function showHideUDRow() {
		setShowHideUDSection(!showHideUDSection);
	}

	return (
		<div>
			<Modal show={props.showHideModal} onHide={props.closeModal} id='lodge_modal'>
				<ModalHeader onHide={props.closeModal} closeButton>
					<Modal.Title>{pageLanguageContent['CLD131'] ? pageLanguageContent['CLD131'] : ''}</Modal.Title>
				</ModalHeader>
				<ModalBody>
					<Row>
						<Col lg={12}>
							<FormGroupInput
								id='lodge-name'
								label={pageLanguageContent['CLD012'] ? pageLanguageContent['CLD012'] : ''}
								placeholder={pageLanguageContent['CLD012'] ? pageLanguageContent['CLD012'] : ''}
								type='text'
								name='name'
								onChange={e => inputsHandler(e, 'name')}
								value={inputField.name}
							/>
							{validation.error_name && <p className='formValidationError'>{validation.error_name}</p>}
						</Col>
						<Col lg={12}>
							<FormGroupInput
								id='number'
								label={pageLanguageContent['CLD013'] ? pageLanguageContent['CLD013'] : ''}
								placeholder={pageLanguageContent['CLD013'] ? pageLanguageContent['CLD013'] : ''}
								type='text'
								name='lodge_number'
								onChange={e => inputsHandler(e, 'number')}
								value={inputField.lodge_number}
							/>
							{validation.error_number && <p className='formValidationError'>{validation.error_number}</p>}
						</Col>
						<Col lg={12}>
							<div className='d-flex lodge-top-item' style={{ marginTop: '-5px' }}>
								<div className='d-flex lodge-top-content'>
									<h6 role='button' onClick={showHideUDRow}>
										{pageLanguageContent['CLD014'] ? pageLanguageContent['CLD014'] : ''}{' '}
										<i className='fas fa-question-circle'></i>
									</h6>
									<div className='ladge-radio-btn'>
										<input
											type='radio'
											id='ud_yes'
											name={'u_d'}
											className='mr-1'
											onChange={e => inputsHandler(e, 'ud')}
											value={true}
											defaultChecked={inputField.u_d ? true : false}
										/>{' '}
										<label htmlFor='ud_yes'>{pageLanguageContent['CLD026'] ? pageLanguageContent['CLD026'] : ''}</label>
										<input
											type='radio'
											id='ud_no'
											name={'u_d'}
											className='mr-1'
											onChange={e => inputsHandler(e, 'ud')}
											value={false}
											defaultChecked={!inputField.u_d ? true : false}
										/>{' '}
										<label htmlFor='ud_no'>{pageLanguageContent['CLD027'] ? pageLanguageContent['CLD027'] : ''}</label>
									</div>
								</div>
							</div>
						</Col>
						<Col lg={12} className='ud_row mt-3'>
							{showHideUDSection && (
								<div className='alert alert-info' role='alert'>
									<i className='fas fa-question-circle'></i>
									<b> {pageLanguageContent['CLD162'] ? pageLanguageContent['CLD162'] : ''}</b>
									<p>
										{pageLanguageContent['CLD163'] ? pageLanguageContent['CLD163'] : ''}{' '}
										{pageLanguageContent['CLD162'] ? pageLanguageContent['CLD162'] : ''}{' '}
										{pageLanguageContent['CLD164'] ? pageLanguageContent['CLD164'] : ''}{' '}
										<i>{pageLanguageContent['CLD165'] ? pageLanguageContent['CLD165'] : ''}</i>{' '}
										{pageLanguageContent['CLD166'] ? pageLanguageContent['CLD166'] : ''}
									</p>

									<p>
										{pageLanguageContent['CLD167'] ? pageLanguageContent['CLD167'] : ''}{' '}
										<b>{pageLanguageContent['CLD168'] ? pageLanguageContent['CLD168'] : ''}</b>{' '}
										{pageLanguageContent['CLD169'] ? pageLanguageContent['CLD169'] : ''}{' '}
									</p>
								</div>
							)}
						</Col>
						<Col lg={12} className='mt-1'>
							<FormGroupInput
								id='formattedLodgeName'
								label={pageLanguageContent['CLD117']}
								type='text'
								value={formattedName}
								disabled
							/>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<div className='alert alert-warning' role='alert'>
								<i className='fas fa-exclamation-triangle'></i>{' '}
								<b>{pageLanguageContent['CLD015'] ? pageLanguageContent['CLD015'] : ''}</b>
								<br />
								{pageLanguageContent['CLD016'] ? pageLanguageContent['CLD016'] : ''}{' '}
								<b>
									<i>{pageLanguageContent['CLD017'] ? pageLanguageContent['CLD017'] : ''}</i>
								</b>{' '}
								{pageLanguageContent['CLD018'] ? pageLanguageContent['CLD018'] : ''}
								<br />
								<br />
								{pageLanguageContent['CLD019'] ? pageLanguageContent['CLD019'] : ''}{' '}
								<b>
									<i> {pageLanguageContent['CLD020'] ? pageLanguageContent['CLD020'] : ''}</i>
								</b>{' '}
								{pageLanguageContent['CLD021'] ? pageLanguageContent['CLD021'] : ''}
							</div>
						</Col>
					</Row>
				</ModalBody>
				<ModalFooter>
					<Button variant='primary' onClick={updateData}>
						{showLoader ? (
							<img src={image_loader} alt='loader' height='20' width='20' />
						) : genPageData['GENSAV'] ? (
							genPageData['GENSAV']
						) : (
							''
						)}
					</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};
export default EditLodgeNameModal;
